module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "gallery-software-list"
  }, _vm._l((_vm.software), function(softwareItem, index) {
    return _c('li', {
      staticClass: "software-wrapper"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'galleries',
          query: {
            software: '' + softwareItem.id
          }
        }
      }
    }, [_c('gallery-software', {
      attrs: {
        "software": softwareItem
      }
    })], 1)], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5cc5b986!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/GallerySoftwareList.vue
// module id = 2055
// module chunks = 2